import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from "@angular/router";
import { AuthService } from "./auth.service";
import { Observable, map, take, catchError, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) { }

  canActivate(
    route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    // Check for b2b_token in query params
    const b2bToken = route.queryParams['b2b_token'];
    if (b2bToken) {
      return this.authService.exchangeToken(b2bToken).pipe(
        map(user => {
          if (user) {
            // Successful exchange, user is logged in
            // Remove the token from URL to clean up
            return this.router.createUrlTree([], { queryParams: { b2b_token: null }, queryParamsHandling: 'merge' });
          } else {
            return this.router.createUrlTree(['login']);
          }
        }),
        catchError(() => {
          return of(this.router.createUrlTree(['login']));
        })
      );
    }

    return this.authService.user.pipe(
      take(1),
      map(user => {
        const isAuth = !!user?.token;

        if (isAuth) {
          return true;
        }
        else {
          return this.router.createUrlTree(['login']);
        }
      })
    )
  }
}

